import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withTranslation } from "react-i18next";
import { Typography, Tabs, Card, Radio } from 'antd';

import { isEmpty } from 'script/common';

const ExecuteResponse = ({ t, interfaceType, webofficeURLParam, adapterName }) => {
	const uniData = useSelector(state => state.uniAdapter[interfaceType]);
	const uniAdapterParam = useSelector(state => state.uniAdapter?.adapterParam);
	/** ========================================================================================================================================== **/
	const dispatch = useDispatch();
	/** ========================================================================================================================================== **/
	const [itemsType, setItemsType] = useState('response');

	const adapterItems = [{
		key: '1',
		label: 'param',
		children: 
			<pre style={{ background: '#f6f6f6', padding: '15px' }}>
				{JSON.stringify({...uniAdapterParam, ...webofficeURLParam}, null, 2)}
			</pre>
	}]

	const requestItems = [{
		key: '1',
		label: 'param',
		children: 
			<pre style={{ background: '#f6f6f6', padding: '15px' }}>
				{JSON.stringify(webofficeURLParam, null, 2)}
			</pre>
	}]

	const responseItems = [
		{
			key: '1',
			label: 'body',
			children: 
				<pre style={{ background: '#f6f6f6', padding: '15px' }}>
					{JSON.stringify(uniData.response.body, null, 2)}
				</pre>
		},
		{
			key: '2',
			label: 'header',
			children: 
				<pre style={{ background: '#f6f6f6', padding: '15px' }}>
					 {JSON.stringify(uniData.response.header, null, 2)}
				</pre>
		},
		{
			key: '3',
			label: 'cookie',
			children: 
				<pre style={{ background: '#f6f6f6', padding: '15px' }}>
					{JSON.stringify(uniData.response.cookie, null, 2)}
				</pre>
		}
	]

	return (
		<>
			<Card
				title="Response"
				type="inner"
				className="uniAdapter-card-blue"
				style={{ marginTop: 20}}
			>
				{uniData.response.status && (
					<div style={{ marginTop: 20 }}>
						<Typography.Text type="success">
							Response Status: {uniData.response.status}
						</Typography.Text>
					</div>
				)}

				{!isEmpty(uniData.response.errorMessage) && (
					<div style={{ marginTop: 20 }}>
						<Typography.Text type="danger">
							Error: {uniData.response.errorMessage}
						</Typography.Text>
					</div>
				)}

				{(uniData.response.body || uniData.response.header || uniData.response.cookie) && (
					<div style={{ marginTop: 20 }}>
						<Radio.Group
							value={itemsType}
							onChange={(e) => {
								const { value } = e.target;
								setItemsType(value);
							}}
							style={{ marginBottom: 16 }}
						>
							<Radio.Button value="response">response</Radio.Button>
							<Radio.Button value="adapter">adapter</Radio.Button>
						</Radio.Group>
						<Tabs
							items={itemsType === 'response' ? responseItems : (interfaceType == 'start' ? requestItems : adapterItems)}
						/>
					</div>
				)}
			</Card>
		</>
	);
}

export default ExecuteResponse;